import React from 'react';
import Icon from '../home/Icon';
import ProductPage from '../product-page/ProductPage';
import { PROJECT_PAGE } from './projectData';
import './ProjectManagement.css';

const COLUMNS = [
  { key: 'todo', label: 'To do', color: '#64748b', cards: [
    { code: 'PRJ-012-9', title: 'Shoot product photos for catalogue', who: 'NK', due: 'Fri', pri: 'Medium', est: '6 h' },
    { code: 'PRJ-012-11', title: 'Draft festive campaign copy', who: 'RS', due: '24 Oct', pri: 'Low', est: '4 h' },
  ] },
  { key: 'doing', label: 'In progress', color: '#0891b2', cards: [
    { code: 'PRJ-012-4', title: 'Website redesign — product pages', who: 'AP', due: 'Today', pri: 'High', est: '18 h', logged: '12.5 h', link: 'SO-1043', sub: '3/5' },
  ] },
  { key: 'review', label: 'Client review', color: '#7c3aed', cards: [
    { code: 'PRJ-012-7', title: 'Brand guidelines v2', who: 'MJ', due: 'Overdue', pri: 'High', est: '10 h', logged: '11 h' },
  ] },
  { key: 'done', label: 'Done', color: '#059669', cards: [
    { code: 'PRJ-012-2', title: 'Kick-off and scope sign-off', who: 'AP', due: 'Done', pri: 'Medium', est: '3 h', logged: '3 h' },
  ] },
];

const dueTone = (due) => (due === 'Overdue' ? 'err' : due === 'Today' ? 'warn' : due === 'Done' ? 'ok' : 'slate');

const BoardMock = () => (
  <div aria-hidden="true">
    <div className="pp-window">
      <div className="pp-window-bar">
        <span className="pp-window-crumb">Projects › PRJ-012 · Sunrise Foods rebrand</span>
        <span className="pm-views"><span className="is-on">Board</span><span>Table</span><span>Calendar</span></span>
      </div>
      <div className="pp-window-body pm-board">
        {COLUMNS.map((col) => (
          <div className="pm-col" key={col.key}>
            <div className="pm-col-head"><i style={{ background: col.color }} />{col.label}<b>{col.cards.length}</b></div>
            {col.cards.map((c) => (
              <div className="pm-card" key={c.code}>
                <span className="pm-code">{c.code}</span>
                <span className="pm-title">{c.title}</span>
                <span className="pm-meta">
                  <span className={`pp-chip pp-chip--${dueTone(c.due)}`}>{c.due}</span>
                  {c.sub && <span className="pm-sub"><Icon name="list-checks" size={11} />{c.sub}</span>}
                  {c.link && <span className="pm-sub"><Icon name="link" size={11} />{c.link}</span>}
                </span>
                <span className="pm-foot">
                  <span className="pm-avatar">{c.who}</span>
                  <span className="pm-hours">{c.logged ? `${c.logged} / ${c.est}` : c.est}</span>
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
    <div className="pp-float pp-float--tr">
      <span className="pp-float-icon pp-float-icon--accent"><Icon name="timer" size={14} /></span>
      <span><strong>2.5 h logged · billable</strong><small>PRJ-012-4 · at ₹400 / h</small></span>
    </div>
    <div className="pp-float pp-float--bl">
      <span className="pp-float-icon pp-float-icon--warn"><Icon name="bell" size={14} /></span>
      <span><strong>Due today: 1 task</strong><small>Reminder sent to Anita P.</small></span>
    </div>
  </div>
);

// Revenue − (direct cost + labour) = margin; cost compared with budget.
const PNL = { revenue: 480000, direct: 162500, hours: 312, rate: 400, budget: 320000 };
const labour = PNL.hours * PNL.rate;
const cost = PNL.direct + labour;
const margin = PNL.revenue - cost;
const inr = (n) => '₹' + n.toLocaleString('en-IN');

const ProjectPnl = () => (
  <div className="pp-doc" style={{ '--pp-doc-cols': 'minmax(0, 1fr) 120px' }} role="img" aria-label="Example project profitability report">
    <div className="pp-doc-head">
      <span>Profitability · PRJ-012 Sunrise Foods rebrand</span>
      <span className="pp-chip pp-chip--ok">From the ledger</span>
    </div>
    <div className="pp-doc-cols"><span>Line</span><span>Amount</span></div>
    <div className="pp-doc-group">
      <div className="pp-doc-row"><span>Revenue <small className="pm-src">· 3 invoices tagged</small></span><span>{inr(PNL.revenue)}</span></div>
      <div className="pp-doc-row"><span>Direct cost <small className="pm-src">· purchases, claims</small></span><span>{inr(PNL.direct)}</span></div>
      <div className="pp-doc-row"><span>Labour <small className="pm-src">· {PNL.hours} h × ₹{PNL.rate}</small></span><span>{inr(labour)}</span></div>
    </div>
    <div className="pp-doc-group">
      <div className="pp-doc-row"><span>Budget used</span><span>{Math.round((cost / PNL.budget) * 100)}% of {inr(PNL.budget)}</span></div>
      <div className="pm-budget"><i style={{ width: `${Math.round((cost / PNL.budget) * 100)}%` }} /></div>
    </div>
    <div className="pp-doc-total"><span>Margin · {((margin / PNL.revenue) * 100).toFixed(1)}%</span><strong>{inr(margin)}</strong></div>
    <div className="pp-doc-foot"><Icon name="info" size={13} />Illustrative project. Figures are excl. GST.</div>
  </div>
);

const ProjectManagementPage = () => (
  <ProductPage page={PROJECT_PAGE} heroVisual={<BoardMock />} booksVisual={<ProjectPnl />} />
);

export default ProjectManagementPage;
